import { Box, Stack, Typography } from "@mui/material";
import { SetupProgressRing } from "Components/Dashboard/SetupChecklist/SetupProgressRing";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import type { ReactNode } from "react";

type Props = {
  title: string;
  subtitle: string;
  completedCount: number;
  totalCount: number;
  children: ReactNode;
};

export const SetupChecklistLayout = ({
  title,
  subtitle,
  completedCount,
  totalCount,
  children,
}: Props) => (
  // The margin lives here rather than in a dashboard wrapper so that the
  // cards' null states leave no zero-height child doubling the Stack gap.
  <PrimaryPaper sx={{ mx: { xs: 1, md: 0 } }}>
    <Stack gap={3}>
      <Box display="flex" alignItems="center" gap={3}>
        <SetupProgressRing value={completedCount} total={totalCount} />
        <Stack>
          <Typography fontWeight={600} fontSize={{ xs: 16, md: 20 }}>
            {title}
          </Typography>
          <Typography color="text.secondary" fontSize={{ xs: 14, md: 16 }}>
            {subtitle}
          </Typography>
        </Stack>
      </Box>
      <Stack>{children}</Stack>
    </Stack>
  </PrimaryPaper>
);
